import { useState, useEffect } from 'react';
import { Modal, Space, Descriptions, Typography } from 'antd';
const { Text } = Typography;
const CONVERT_STATUS = {
    '4': '待计算',
    '5': '计费异常',
    '6': '待出账',
    '7': '已出账',
}
function CalculationModal ({ open, setOpen, loading, onSubmit, content, isFilter, customerUidData, billingInvoiceNames }) {
    
    const [convertedContent, setConvertedContent] = useState(content);

    const getUid = (customerId) => {
        const customer = customerUidData.find(item => item.id === customerId);
        if (customer) {
            return customer.uid;
        }
        return null;
    }

    const getBillingInvoiceName = (billingInvoiceId) => {
        const billingInvoice = billingInvoiceNames.find(item => item.id === billingInvoiceId);
        if (billingInvoice) {
            return billingInvoice.name;
        }
        return null;
    }

    useEffect(() => {
        if (isFilter) {
            setConvertedContent({
                '状态': CONVERT_STATUS[content.status],
                'Tracking Number': content.tracking_number,
                'Master Tracking': content.master_tracking_number,
                'UID': getUid(content.uid),
                'Shipment Date': content.shipment_date,
                '物流服务': content.service_type,
                '导入批次编号': getBillingInvoiceName(content.billing_invoice),
            })
        }
    }, [content, isFilter]);
    
    const handleOk = () => {
        onSubmit();
    }

    return (
        <Modal
            title="计算运费"
            open={open}
            onCancel={() => setOpen(false)}
            onOk={handleOk}
            centered
            confirmLoading={loading}
        >
            <Space direction="vertical">
                {isFilter ? <Text>将对以下查询结果进行处理：</Text> : <Text>将对以下内容进行处理：</Text>}
                {isFilter ? (
                    <Descriptions column={1} layout="vertical" size="small">
                        {Object.entries(convertedContent).map(([key, value], index) => {
                                if (value) {
                                    if (key === 'Tracking Number') {
                                        // take the first 12 tracking number
                                        return <Descriptions.Item>{key}: {value.split(',').slice(0, 12).join(", ")}{value.length > 12 ? "..." : ""}</Descriptions.Item>
                                    }
                                    return <Descriptions.Item>{key}: {value}</Descriptions.Item>
                                }
                            }
                            )
                        }
                    </Descriptions>
                ) : (
                    // only show the first 20, if there are more than 20, use elipsis
                    <Space direction="horizontal">
                        <Text style={{ whiteSpace: 'nowrap' }}>
                            Tracking Number:
                        </Text>
                        <Text>
                            {content.slice(0, 12).map(item => item.tracking_number).join(', ')}
                            {content.length > 12 ? "..." : ""}
                        </Text>
                    </Space>
                )}
            </Space>
        </Modal>
    );
}

export default CalculationModal;